import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

import styles from './Dialog.module.scss'

const Dialog = ({ children, verticalPadding = 30 }) => {
  let modalRoot = document.getElementById('modalRoot')

  if (!modalRoot) {
    modalRoot = document.createElement('div')
    modalRoot.setAttribute('id', 'modalRoot')
    document.body.appendChild(modalRoot)
  }

  const rootElemRef = useRef(document.createElement('div'))

  useEffect(() => {
    if (modalRoot) {
      document.body.classList.add('dialog-open')
      modalRoot.insertBefore(rootElemRef.current, modalRoot.firstChild)
    }

    return () => {
      if (modalRoot.childElementCount < 2) {
        document.body.classList.remove('dialog-open')
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
      modalRoot.removeChild(rootElemRef.current)
    }
  }, [modalRoot])

  return createPortal(
    <>
      <div className={styles.overlay}></div>
      <div
        className={styles.holder}
        style={{ '--dialogVerticalPadding': `${verticalPadding}px` }}
      >
        <div style={{ margin: 'auto' }}>{children}</div>
      </div>
    </>,
    rootElemRef.current
  )
}

export default Dialog

Dialog.propTypes = {
  children: PropTypes.node.isRequired
}
